import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  FormControl,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Eye, EyeOff } from "react-feather";
import PasswordChecklist from "react-password-checklist";
import { useSearchParams } from "react-router-dom";
import { Context, useCurrentProfile } from "../../ContextWrapper";
import NotificationContainer from "../generic/updateNotification";

export const Password = ({
  setNavIndex = null,
  setNavVisible = null,
  trigger,
}) => {
  const [isMobile] = useMediaQuery("(max-width: 1280px)");

  const [searchParams] = useSearchParams();
  const context = React.useContext(Context);
  const [isPassValid, setIsPassValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { profile } = useCurrentProfile();

  const [profileData, setProfileData] = useState({});

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password1, setPassword1] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [password2, setPassword2] = useState("");
  const [showPassword2, setShowPassword2] = useState(false);

  const handleShowClick = () => setShowPassword(!showPassword);
  const handleShowClick1 = () => setShowPassword1(!showPassword1);
  const handleShowClick2 = () => setShowPassword2(!showPassword2);
  const handleCancel = () => {
    setPassword("");
    setPassword1("");
    setPassword2("");
  };

  const s = searchParams.get("s");

  const submit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    const data = {
      s: s,
      email: profileData?.user?.email,
      oldPassword: password,
      password: password1,
    };

    try {
      const res = await axios.post(
        "/api/v2/resetpassword/",
        data,
        {
          headers: { "Content-Type": "application/json" },
        },
        { withCredentials: true }
      );

      if (res.data.reset) {
        var header = "Update Password";
        var msg = "Password updated successfully";
        context.fireToast(header, msg, "success");

        setPassword("");
        setPassword1("");
        setPassword2("");
      } else {
        context.fireToast(
          "Update password",
          "Failed to update password. Please ensure your old password is correct.",
          "error"
        );
      }
    } catch (error) {
      context.fireToast(
        "Update password",
        "Failed to update password. Please try again.",
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController(); // AbortController for request cancellation
    let isActive = true; // Flag to track active state

    const refreshProfileData = async (id) => {
      if (id) {
        try {
          const res = await axios.get(`/api/v2/profiles/${id}/`, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
            signal: controller.signal, // Attach the signal for cancellation
          });
          if (isActive) {
            setProfileData(res.data); // Update state only if the effect is active
          }
        } catch (err) {
          if (err?.response) {
            console.log(err);
          }
        }
      }
    };

    refreshProfileData(profile.id);

    return () => {
      isActive = false;
      controller.abort();
    };
  }, [profile]);

  return (
    <Box pt={!isMobile ? "100px" : "150px"} pl={"24px"} pr={"24px"} pb={"24px"}>
      <NotificationContainer rounded={true} p={"0px 0px 24px"} />
      <form onSubmit={submit}>
        <Card borderRadius={"12px"}>
          <CardHeader p={0} borderBottom={"1px"} borderColor={"#DEE2E6"}>
            <Box padding={"24px 20px"}>
              <Text
                display={"flex"}
                alignItems={"center"}
                fontSize={"22px"}
                height={"30px"}
                fontWeight={600}
                color={"#1A202C"}
                mb={"5px"}
              >
                Password Settings
              </Text>
              <Text
                display={"flex"}
                alignItems={"center"}
                fontSize={"15px"}
                height={"30px"}
                fontWeight={400}
                color={"#4A5568"}
              >
                Set a strong password to protect your account.
              </Text>
            </Box>
          </CardHeader>
          <CardBody height={"700px"} p={"24px 20px"}>
            <Box minW={{ base: "90%", md: "468px" }}>
              <FormControl>
                <Input
                  type="text"
                  name="email"
                  autoComplete="email"
                  value={profileData?.user?.email || ""}
                  readOnly
                  hidden
                />
              </FormControl>
              <FormControl w={"auto"} maxW={"374px"}>
                <Text fontWeight={500} fontSize={"16px"} mb={2}>
                  Current Password
                </Text>
                <InputGroup>
                  <Input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your current password"
                    value={password}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <InputRightElement width="50px">
                    <Button
                      h="15px"
                      w={"20px"}
                      backgroundColor={"#FFFFFF"}
                      _hover={{ bg: "#FFFFFF" }}
                      color={"#0A101B"}
                      p={0}
                      onClick={handleShowClick}
                    >
                      {showPassword ? (
                        <EyeOff size={"15px"}></EyeOff>
                      ) : (
                        <Eye size={"15px"}></Eye>
                      )}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <FormControl w={"auto"} maxW={"374px"}>
                <Text fontWeight={500} pt={"20px"} fontSize={"16px"} mb={2}>
                  New Password
                </Text>
                <InputGroup>
                  <Input
                    type={showPassword1 ? "text" : "password"}
                    placeholder="Enter your new password"
                    value={password1}
                    required
                    onChange={(e) => setPassword1(e.target.value)}
                    autoComplete="new-password"
                  />
                  <InputRightElement width="50px">
                    <Button
                      h="15px"
                      w={"20px"}
                      backgroundColor={"#FFFFFF"}
                      _hover={{ bg: "#FFFFFF" }}
                      color={"#0A101B"}
                      p={0}
                      onClick={handleShowClick1}
                    >
                      {showPassword1 ? (
                        <EyeOff size={"15px"}></EyeOff>
                      ) : (
                        <Eye size={"15px"}></Eye>
                      )}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <FormControl w={"auto"} maxW={"374px"}>
                <Text fontWeight={500} pt={"20px"} fontSize={"16px"} mb={2}>
                  Confirm Password
                </Text>
                <InputGroup mb={4}>
                  <Input
                    type={showPassword2 ? "text" : "password"}
                    placeholder="Confirm new password"
                    value={password2}
                    required
                    onChange={(e) => setPassword2(e.target.value)}
                    autoComplete="new-password"
                  />
                  <InputRightElement width="50px">
                    <Button
                      h="15px"
                      w={"20px"}
                      backgroundColor={"#FFFFFF"}
                      _hover={{ bg: "#FFFFFF" }}
                      color={"#0A101B"}
                      p={0}
                      onClick={handleShowClick2}
                    >
                      {showPassword2 ? (
                        <EyeOff size={"15px"}></EyeOff>
                      ) : (
                        <Eye size={"15px"}></Eye>
                      )}
                    </Button>
                  </InputRightElement>
                </InputGroup>
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={5}
                  value={password1}
                  valueAgain={password2}
                  onChange={(isValid) => {
                    setIsPassValid(isValid);
                  }}
                />
              </FormControl>
            </Box>
          </CardBody>
          <CardFooter pt={"4px"} pb={"32px"}>
            <Box display={"block"} width={"100%"}>
              <Box>
                {(password || password1 || password2) && (
                  <Box
                    width={"100%"}
                    textAlign={"right"}
                    pt={"24px"}
                    display="flex"
                    justifyContent="flex-end"
                    gap="16px" // Add space between the buttons
                  >
                    {" "}
                    <Button
                      variant="outline"
                      fontSize={"16px"}
                      fontWeight={"500"}
                      height={"36px"}
                      width={"90px"}
                      onClick={handleCancel}
                      disabled={isSubmitting}
                      opacity={isSubmitting ? 0.5 : 1}
                      cursor={isSubmitting ? "not-allowed" : "pointer"}
                    >
                      Cancel
                    </Button>
                    {isPassValid && password && (
                      <Button
                        type="submit"
                        fontSize={"16px"}
                        fontWeight={"500"}
                        height={"36px"}
                        width={"90px"}
                        disabled={isSubmitting}
                        opacity={isSubmitting ? 0.5 : 1}
                        cursor={isSubmitting ? "not-allowed" : "pointer"}
                      >
                        Save
                      </Button>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </CardFooter>
        </Card>{" "}
      </form>
    </Box>
  );
};
